module.exports = __webpack_public_path__ + "img/toprimg.0c067e3d.png";